import { useEffect } from 'react';
import { useParticipants, useRoomContext } from '@livekit/components-react';

/**
 * Component to manage participant state updates and handle reconnection scenarios
 * This ensures video tracks are properly refreshed when participants reconnect
 */
function ParticipantStateManager() {
  const participants = useParticipants();
  const roomContext = useRoomContext();
  const room = roomContext?.room;

  useEffect(() => {
    if (!room) return;

    const handleParticipantConnected = (participant) => {
      console.log('Participant connected/reconnected:', participant.identity);
      
      // When a participant reconnects, their tracks will be automatically resubscribed
      // We just log it for debugging
    };

    const handleParticipantDisconnected = (participant) => {
      console.log('Participant disconnected:', participant.identity);
    };

    const handleTrackSubscribed = (track, publication, participant) => {
      console.log('Track subscribed:', track.kind, participant.identity);
      
      // LiveKit components handle track attachment automatically
      // This is mainly for logging and debugging
    };

    const handleTrackUnsubscribed = (track, publication, participant) => {
      console.log('Track unsubscribed:', track.kind, participant.identity);
    };

    // Listen to participant events
    room.on('participantConnected', handleParticipantConnected);
    room.on('participantDisconnected', handleParticipantDisconnected);
    room.on('trackSubscribed', handleTrackSubscribed);
    room.on('trackUnsubscribed', handleTrackUnsubscribed);

    return () => {
      room.off('participantConnected', handleParticipantConnected);
      room.off('participantDisconnected', handleParticipantDisconnected);
      room.off('trackSubscribed', handleTrackSubscribed);
      room.off('trackUnsubscribed', handleTrackUnsubscribed);
    };
  }, [room, participants]);

  return null; // This component doesn't render anything
}

export default ParticipantStateManager;

